import { render, staticRenderFns } from "./SurveyStruct2.vue?vue&type=template&id=f7473430&"
import script from "./SurveyStruct2.vue?vue&type=script&lang=js&"
export * from "./SurveyStruct2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports